// Oliver Sweeney — Shared helpers
// No dependencies.

class OSHelpers {
  static formatMoney(cents, format = '[[amount]]') {
    if (typeof cents === 'string') cents = cents.replace('.', '')
    const placeholderRegex = /\[\[\s*(\w+)\s*\]\]/
    let value = ''
    switch (format.match(placeholderRegex)[1]) {
      case 'amount':                                  value = this.formatWithDelimiters(cents, 2);       break
      case 'amount_no_decimals':                      value = this.formatWithDelimiters(cents, 0);       break
      case 'amount_with_comma_separator':             value = this.formatWithDelimiters(cents, 2, '.', ','); break
      case 'amount_no_decimals_with_comma_separator': value = this.formatWithDelimiters(cents, 0, '.', ','); break
    }
    const currency = window.Shopify?.currency?.active ?? 'GBP'
    const symbols  = { GBP: '£', EUR: '€', USD: '$', CAD: '$', AUD: '$' }
    return (symbols[currency] ?? '') + format.replace(placeholderRegex, value)
  }

  static formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) return 0
    number = (number / 100.0).toFixed(precision)
    const parts   = number.split('.')
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`)
    const cents   = parts[1] ? (decimal + parts[1]) : ''
    return cents === '.00' ? dollars : dollars + cents
  }

  static getSizedImageUrl(src, size) {
    if (!size || size === 'master') return src.replace(/http(s)?:/, '')
    const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i)
    if (!match) return null
    return (src.split(match[0])[0] + '_' + size + match[0]).replace(/http(s)?:/, '')
  }

  static scrollTo(target, offset = 0) {
    const el = typeof target === 'string' ? document.querySelector(target) : target
    if (!el) return
    window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset + offset, behavior: 'smooth' })
  }
}

window.OSHelpers = OSHelpers
